// ============================================================================
// RANGE TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'range-tree-ds',
  name: 'Range Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log² n + k)',
    space: 'O(n log n)'
  },
  description: 'Range Tree is a data structure for efficient range searching in multi-dimensional space. It is a balanced binary tree on the first dimension, where each node contains a data structure for the second dimension. Allows orthogonal range queries in logarithmic time.'
};
